import { AxiosInstance } from 'axios';

export const baseEndpoint = 'brand-image';

export interface GenerateBrandImageParams {
  // Domain mode (spends cached Brandfetch quota): supplies color + logo + title.
  domain?: string;
  // Manual mode (zero quota): provide a hex color and title, optionally a logo file.
  hex?: string;
  title?: string;
  logo?: File | null;
  // false when the logo is itself a wordmark (avoid duplicating the name).
  showName?: boolean;
}

export interface GeneratedBrandImage {
  image: string; // PNG data URL
  brandColor: string;
  title: string;
}

export class BrandImageApi {
  constructor(private api: AxiosInstance) {}

  async generate(params: GenerateBrandImageParams): Promise<GeneratedBrandImage> {
    const formData = new FormData();
    if (params.domain) formData.append('domain', params.domain);
    if (params.hex) formData.append('hex', params.hex);
    if (params.title) formData.append('title', params.title);
    if (params.showName !== undefined) formData.append('showName', String(params.showName));
    if (params.logo) formData.append('logo', params.logo);

    const response = await this.api.post('/generate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  }
}
